import { atom, useAtom } from "jotai";

const hoveredRowIndex = atom<null | string>(null);

export const useActiveHoveredChartRow = () => {
  const [activeHoveredChartRow, setActiveHoveredChartRow] =
    useAtom(hoveredRowIndex);

  return [activeHoveredChartRow, setActiveHoveredChartRow] as const;
};
